(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.lpProVoicesInit === 'true') return;
    root.dataset.lpProVoicesInit = 'true';

    var track = root.querySelector('[data-lp-pv-track]');
    var progressBar = root.querySelector('[data-lp-pv-progress]');
    var btnPrevAll = root.querySelectorAll('[data-lp-pv-prev]');
    var btnNextAll = root.querySelectorAll('[data-lp-pv-next]');
    var modal = root.querySelector('[data-lp-pv-modal]');
    var modalIframe = root.querySelector('[data-lp-pv-modal-iframe]');
    var modalClose = root.querySelector('[data-lp-pv-modal-close]');
    var modalBackdrop = root.querySelector('[data-lp-pv-modal-backdrop]');
    var modalDialog = root.querySelector('[data-lp-pv-modal-dialog]');

    if (!track) return;

    var loopEnabled = root.classList.contains('lp-pro-voices--loop');
    var suppressClick = false;
    var DRAG_START = 4;
    var DRAG_LOCK = 10;
    var dragState = {
      active: false,
      moved: false,
      axisLocked: false,
      isHorizontal: false,
      startX: 0,
      startY: 0,
      startScroll: 0,
      pointerId: null
    };

    function getOriginalItems() {
      return Array.prototype.slice.call(track.querySelectorAll('[data-lp-pv-item]:not([data-lp-pv-clone])'));
    }

    function getAllItems() {
      return Array.prototype.slice.call(track.querySelectorAll('[data-lp-pv-item]'));
    }

    function getGap() {
      return parseFloat(getComputedStyle(track).gap) || 0;
    }

    function getSetWidth() {
      var originals = getOriginalItems();
      if (!originals.length) return 0;
      var first = originals[0];
      var last = originals[originals.length - 1];
      return last.offsetLeft + last.offsetWidth - first.offsetLeft + getGap();
    }

    function setupLoopClones() {
      if (!loopEnabled) return;

      var originals = getOriginalItems();
      if (!originals.length) return;

      track.querySelectorAll('[data-lp-pv-clone]').forEach(function (node) {
        node.remove();
      });

      for (var pass = 0; pass < 2; pass += 1) {
        originals.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute('data-lp-pv-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          track.appendChild(clone);
        });
      }

      for (var i = originals.length - 1; i >= 0; i -= 1) {
        var leadingClone = originals[i].cloneNode(true);
        leadingClone.setAttribute('data-lp-pv-clone', 'true');
        leadingClone.setAttribute('aria-hidden', 'true');
        leadingClone.removeAttribute('data-shopify-editor-block');
        track.insertBefore(leadingClone, track.firstChild);
      }

      var setWidth = getSetWidth();
      if (setWidth > 0) {
        track.scrollLeft = setWidth;
      }
    }

    function normalizeLoopScroll() {
      if (!loopEnabled) return;

      var setWidth = getSetWidth();
      if (!setWidth) return;

      if (track.scrollLeft <= setWidth * 0.25) {
        track.scrollLeft += setWidth;
      } else if (track.scrollLeft >= setWidth * 2.75) {
        track.scrollLeft -= setWidth;
      }
    }

    function getStep() {
      var items = getAllItems();
      if (!items.length) return track.clientWidth;
      return items[0].getBoundingClientRect().width + getGap();
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function getIndex() {
      var step = getStep();
      if (!step) return 0;
      return Math.round(track.scrollLeft / step);
    }

    function scrollToIndex(index) {
      var items = getOriginalItems();
      if (!items.length) return;
      var safeIndex = Math.max(0, Math.min(index, items.length - 1));
      scrollItemIntoView(items[safeIndex], loopEnabled ? 'center' : 'start');
    }

    function scrollItemIntoView(item, align) {
      if (!item) return;
      var trackRect = track.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var delta = itemRect.left - trackRect.left;
      if (align === 'center') {
        delta -= (track.clientWidth - itemRect.width) / 2;
      }
      var maxScroll = getMaxScroll();
      var targetLeft = Math.max(0, Math.min(maxScroll, track.scrollLeft + delta));
      track.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }

    function scrollByStep(direction) {
      var step = getStep();
      if (!step) return;
      var maxScroll = getMaxScroll();
      var targetLeft = track.scrollLeft + direction * step;
      track.scrollTo({
        left: Math.max(0, Math.min(maxScroll, targetLeft)),
        behavior: 'smooth'
      });
    }

    function updateCenterCard() {
      if (!loopEnabled) return;

      var items = getAllItems();
      if (!items.length) return;

      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var closest = null;
      var closestDist = Infinity;

      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var dist = Math.abs(itemCenter - trackCenter);
        item.classList.remove('is-center');
        if (dist < closestDist) {
          closestDist = dist;
          closest = item;
        }
      });

      if (closest) closest.classList.add('is-center');
    }

    function updateUI() {
      var maxScroll = getMaxScroll();
      var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      if (progressBar) progressBar.style.width = ratio * 100 + '%';
      var atStart = !loopEnabled && track.scrollLeft <= 2;
      var atEnd = !loopEnabled && track.scrollLeft >= maxScroll - 2;
      btnPrevAll.forEach(function (btn) {
        btn.disabled = atStart;
      });
      btnNextAll.forEach(function (btn) {
        btn.disabled = atEnd;
      });
      updateCenterCard();
    }

    function resetDragState() {
      dragState.active = false;
      dragState.moved = false;
      dragState.axisLocked = false;
      dragState.isHorizontal = false;
      dragState.pointerId = null;
      track.classList.remove('is-dragging');
    }

    function isHorizontalGesture(deltaX, deltaY) {
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      return absX >= absY || (absX >= DRAG_START && absX > absY);
    }

    function onPointerDown(event) {
      if (event.pointerType === 'touch') return;
      if (event.button !== undefined && event.button !== 0) return;
      if (event.target.closest('.lp-pro-voices__creator')) return;

      dragState.active = true;
      dragState.moved = false;
      dragState.axisLocked = false;
      dragState.isHorizontal = false;
      dragState.startX = event.clientX;
      dragState.startY = event.clientY;
      dragState.startScroll = track.scrollLeft;
      dragState.pointerId = event.pointerId;
    }

    function onPointerMove(event) {
      if (!dragState.active || event.pointerId !== dragState.pointerId) return;

      var deltaX = event.clientX - dragState.startX;
      var deltaY = event.clientY - dragState.startY;

      if (!dragState.axisLocked) {
        if (Math.abs(deltaX) < DRAG_START && Math.abs(deltaY) < DRAG_START) return;
        dragState.axisLocked = true;
        dragState.isHorizontal = isHorizontalGesture(deltaX, deltaY);
      }

      if (!dragState.isHorizontal) return;
      if (Math.abs(deltaX) < DRAG_LOCK) return;

      if (!dragState.moved) {
        dragState.moved = true;
        track.classList.add('is-dragging');
        if (track.setPointerCapture && event.pointerId != null) {
          try {
            track.setPointerCapture(event.pointerId);
          } catch (e) {
            /* ignore */
          }
        }
      }

      event.preventDefault();
      track.scrollLeft = dragState.startScroll - deltaX;
      normalizeLoopScroll();
      updateUI();
    }

    function endDrag(event) {
      if (!dragState.active) return;
      if (event && event.pointerId != null && dragState.pointerId != null && event.pointerId !== dragState.pointerId) {
        return;
      }

      if (track.releasePointerCapture && dragState.pointerId != null) {
        try {
          track.releasePointerCapture(dragState.pointerId);
        } catch (e) {
          /* ignore */
        }
      }

      var shouldSuppress = dragState.moved;
      resetDragState();
      normalizeLoopScroll();
      updateUI();

      if (shouldSuppress) {
        suppressClick = true;
        window.setTimeout(function () {
          suppressClick = false;
        }, 300);
      }
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove, { passive: false });
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    function closeModal() {
      if (!modal || !modalIframe) return;
      modalIframe.removeAttribute('src');
      modal.classList.remove('is-open');
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    function openModal(youtubeId, startSeconds) {
      if (!modal || !modalIframe || !youtubeId) return;
      var embed =
        'https://www.youtube.com/embed/' +
        youtubeId +
        '?autoplay=1&rel=0&playsinline=1&enablejsapi=1';
      var start = parseInt(String(startSeconds || ''), 10);
      if (start > 0) embed += '&start=' + start;
      modalIframe.src = embed;
      modal.removeAttribute('hidden');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    track.addEventListener(
      'click',
      function (event) {
        if (event.target.closest('.lp-pro-voices__creator')) return;
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
          return;
        }

        var cardItem = event.target.closest('[data-lp-pv-item]');
        if (!cardItem) return;
        var youtubeId = cardItem.getAttribute('data-youtube-id');
        if (!youtubeId) return;
        event.preventDefault();
        openModal(youtubeId, cardItem.getAttribute('data-youtube-start'));
      },
      false
    );

    if (modalClose) {
      modalClose.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
      });
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (!modal.classList.contains('is-open')) return;
        if (modalDialog && modalDialog.contains(event.target)) return;
        closeModal();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    track.addEventListener(
      'dragstart',
      function (event) {
        if (event.target.closest('[data-lp-pv-card], .lp-pro-voices__thumb-img')) {
          event.preventDefault();
        }
      },
      false
    );

    btnPrevAll.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        if (loopEnabled) {
          scrollToIndex(getIndex() - 1);
        } else {
          scrollByStep(-1);
        }
      });
    });

    btnNextAll.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        if (loopEnabled) {
          scrollToIndex(getIndex() + 1);
        } else {
          scrollByStep(1);
        }
      });
    });

    var scrollTimer = 0;
    track.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          normalizeLoopScroll();
          updateUI();
        }, 80);
        updateUI();
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      function () {
        if (loopEnabled) setupLoopClones();
        updateUI();
      },
      { passive: true }
    );

    setupLoopClones();
    updateUI();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-lp-pro-voices]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
